/* global $R */

import map from 'lodash/map';

import definedlinksAutocomplete from './DefinedLinksAutocomplete';

$R.add('plugin', 'definedlinks', {
  init(app) {
    this.app = app;
    this.opts = app.opts;

    this.component = app.component;

    this.links = [];
  },

  // messages
  onmodal: {
    link: {
      open($modal, $form) {
        if (!this.opts.definedlinks) return;

        this.$modal = $modal;
        this.$form = $form;

        if (!this.opts.definedlinksAutocomplete) {
          this.$selector = this.buildBaseSelect();
          this.loadPredefinedLinks();
        } else {
          const autocomplete = Object.assign({}, definedlinksAutocomplete);
          autocomplete.init(this);
          autocomplete.buildAutocomplete();
        }
      },
    },
  },

  /**
   * Load defined links
   * @return {void}
   */
  loadPredefinedLinks() {
    if (typeof this.opts.definedlinksCache !== 'undefined') {
      return this.buildSelect(this.opts.definedlinksCache);
    }

    if (typeof this.opts.definedlinks === 'object') {
      this.buildSelect(this.opts.definedlinks);
    } else {
      window.axios.get(this.opts.definedlinks)
        .then((res) => {
          this.opts.definedlinksCache = res.data;
          this.buildSelect(res.data);
        });
    }

    return true;
  },

  /**
   * Create select box in modal
   * @param {Object} data
   */
  buildSelect(data) {
    this.links = [];

    this.$selector.html(this.buildSelectOptions(data));
    this.$selector.off('change');
    this.$selector.on('change', this.select.bind(this));
  },

  /**
   * Build the base select element
   *
   * @return {HTMLSelectNode}
   */
  buildBaseSelect() {
    let $selector = this.$modal.find('#redactor-defined-links');

    if ($selector.length === 0) {
      const $body = this.$modal.getBody();
      const $item = $R.dom('<div class="form-item" />');
      $selector = $R.dom('<select id="redactor-defined-links" />');

      $item.append($selector);
      $body.prepend($item);
    } else {
      $selector.val(0);
    }

    return $selector;
  },

  /**
   * Build select options HTML
   *
   * @param  {object} data
   * @return {string}
   */
  buildSelectOptions(data) {
    let index = 1;

    const html = map(data, (pages, name) => {
      const options = pages.map((item) => {
        this.links[index] = item;

        index += 1;

        return `
          <option value="${index - 1}">
            ${item.title} (${item.url})
          </option>
        `;
      });

      return `
        <optgroup label="${name}">
          ${options.join('')}
        </optgroup>
      `;
    });

    return `
      <option value="0">
        Selecteer link
      </option>
      ${html.join('')}
    `;
  },

  /**
   * Handle option select
   *
   * @param  {object} e
   * @return {void}
   */
  select(e) {
    const formData = this.$form.getData();
    const key = $R.dom(e.target).val();
    const data = {
      text: '',
      url: '',
      title: '',
      rel: typeof formData.rel !== 'undefined' ? formData.rel : '',
    };

    if (key !== '0') {
      data.text = this.links[key].title;
      data.url = this.links[key].url;
      data.title = this.links[key].title;
    }

    if (formData.text !== '') {
      delete data.text;
    }

    if (formData.title !== '') {
      delete data.title;
    }

    this.$form.setData(data);
  },
});
